import React from "react";
import "./styles.scss";

interface IProps {
  text: string;
  icon: any;
  onClick(): void;
  disabled?: boolean;
}

const MediaButton = (props: IProps) => {
  return (
    <div
      className={props.disabled ? "media-button-disabled" : "media-button"}
      onClick={() => !props.disabled && props.onClick()}
    >
      <div>
        <div className="media-button-icon">{props.icon}</div>
        <div className="media-button-text"> {props.text}</div>
      </div>
    </div>
  );
};

export default MediaButton;
